export default {
  getSvaUuidEditing: state => state.svaUuidEditing,
  getSvaAlreadyFetchEditing: state => state.svaAlreadyFetchEditing,
  getSvaName: state => state.svaName,
  getSvaPrice: state => state.svaPrice,
  getSvaCategorySelected: state => state.svaCategorySelected,
  getSvaOptionsCategories: state => state.svaOptionsCategories,
  getSvaScore: state => state.svaScore,
  getSvaActive: state => state.svaActive,
  getSvaIcon: state => state.svaIcon,
  getSvaIconPreview: state => state.svaIconPreview,
  getSvaRelatedPlans: state => state.svaRelatedPlans,

  getSvasOptions: state => state.svasOptions,
  getSvasSelecteds: state => state.svasSelecteds
}
